import React from 'react';
import { Modal } from '../_components';
import { NewMapForm } from './forms';

export function NewMap(props) {
  const { mapItem, prevModal } = props;
  // const { closeModal } = useModal();
  let title =
    mapItem && mapItem.title ? `Edit Map: ${mapItem.title}` : 'New Map';

  return (
    <Modal
      id="newMapModal"
      // backdrop
      title={title}
      icon="far fa-map"
      size="lg"
      open={true}
    >
      <NewMapForm mapData={mapItem} prevModal={prevModal} />
    </Modal>
  );
}
